import React from 'react'

const DeleteImageIcon: React.FC = () => {

    return (
        <svg width="29" height="28" xmlns="http://www.w3.org/2000/svg" fill="none">
            <g>
            <path stroke="null" id="svg_4" fill="#ffffff" d="m2.5171,14c0,-6.52356 5.36493,-11.81197 11.9829,-11.81197c6.61794,0 11.9829,5.28841 11.9829,11.81197c0,6.52354 -5.36496,11.81197 -11.9829,11.81197c-6.61797,0 -11.9829,-5.28843 -11.9829,-11.81197z"/>
            <path stroke="null" id="svg_1" fill="#1E1E1E" d="m4.69658,14c0,-5.34347 4.38914,-9.67522 9.80342,-9.67522c5.41425,0 9.80342,4.33174 9.80342,9.67522c0,5.34345 -4.38917,9.67522 -9.80342,9.67522c-5.41428,0 -9.80342,-4.33177 -9.80342,-9.67522z"/>
            <path id="svg_2" fill="white" d="m20.5,9.09091l-1.0909,-1.09091l-4.9091,4.9091l-4.90909,-4.9091l-1.09091,1.09091l4.9091,4.90909l-4.9091,4.9091l1.09091,1.0909l4.90909,-4.9091l4.9091,4.9091l1.0909,-1.0909l-4.9091,-4.9091l4.9091,-4.90909z"/>
            </g>
        </svg>
    )
}

export default DeleteImageIcon
